module.exports = __webpack_public_path__ + "static/work_BB_BF_full-b5095bf6a459fa3a7d62eb9ca4972635.mp4";